module.exports = __webpack_public_path__ + "img/2-4.c2247e6f.svg";